<template>
	<div class="col-md-6 col-sm-6 col-xs-12">
		<div class="stories-box clearfix">
			<router-link :to="{ name: 'storiesDetail', params: { code: story.request_type.id, slug: story.slug } }">
				{{ story.title }}
			</router-link>
			<div class="story-text">
				{{ story.text }}
			</div>
			<div class="story-info">
				<div class="story-author">
					{{ story.author }}
				</div>
				<div class="story-date">
					{{ story.created_at | formatDate(false) }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'StoriesContainerBox',
	props: {
		story: {
			type: Object,
			required: true,
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/components/sections/boxes/StoriesContainerBox.vue